/* ============================================================
   HealthyHeads — Cart Drawer
   Losstaand van de PDP. Leest live uit /cart.js, muteert via
   /cart/change.js. Alles herberekent na elke wijziging.

   PERFORMANCE-VERSIE — wijzigingen t.o.v. de vorige versie:
   1. getCart() dedupliceert gelijktijdige aanvragen (één fetch i.p.v. zes).
   2. draw() slaat het hertekenen over als de cart niet gewijzigd is.
   3. open() haalt niet meer zelf op als de aanroeper dat al deed.
   4. De +/- knoppen werken direct in beeld en versturen gebundeld (debounce).
   5. De eigen upsell-knop triggert de fetch-interceptor niet meer.
   6. De USP-carrousel staat stil zolang de drawer dicht is.
   Alle bestaande functionaliteit is ongewijzigd.
   ============================================================ */
(function () {
  "use strict";

  var root = document.querySelector("[data-hh-cart]");
  if (!root) return;

  var FREE = parseInt(root.getAttribute("data-free-threshold"), 10) || 4900;
  var GIFT = parseInt(root.getAttribute("data-gift-threshold"), 10) || 0;
  // De balk loopt tot de hoogste mijlpaal, zodat beide punten erop passen.
  var BAR_MAX = parseInt(root.getAttribute("data-bar-max"), 10) || Math.max(FREE, GIFT) || FREE;
  var SHIP = parseInt(root.getAttribute("data-ship-cost"), 10) || 595;

  /* ---------- chews: vaste van-prijs per pot ----------
     Voor de chews-producten ontbreekt de compare_at_price op de cart-variant
     (bundels zijn quantity, geen aparte variant). Daarom rekenen we voor deze
     producten met een vaste adviesprijs van €35,50 per pot, zodat de van-prijs
     en korting overeenkomen met de PDP-bundelkaart (1 pot 15%, 2 potten 25%,
     3 potten 33%). Andere producten gebruiken hun eigen compare_at_price. */
  var CHEWS_PRODUCT_IDS = {
    "15130564886903": true, // Darmflora
    "15130563707255": true, // Anti-Jeuk
    "15130538246519": true  // Complete Support+
  };
  var CHEWS_COMPARE_PER_UNIT = 3550; // €35,50 per pot (in centen)

  /* Bundelprijzen chews (in centen). Het kortingspercentage in de nudge wordt
     hieruit berekend, zodat de tekst meeloopt als de prijzen ooit wijzigen. */
  var CHEWS_BUNDLE_PRICES = { 2: 5285, 3: 7095, 5: 10645 };

  var linesEl = root.querySelector("[data-hh-cart-lines]");
  var tpl = root.querySelector("[data-hh-cart-line-tpl]");
  var countEl = root.querySelector("[data-hh-cart-count]");
  var emptyEl = root.querySelector("[data-hh-cart-empty]");
  var footEl = root.querySelector("[data-hh-cart-foot]");
  var bodyEl = root.querySelector("[data-hh-cart-body]");
  var scrollFadeEl = root.querySelector("[data-hh-cart-scrollfade]");
  var upsellsEl = root.querySelector("[data-hh-cart-upsells]");

  /* footer-elementen één keer opzoeken i.p.v. bij elke render */
  var subtotalEl = root.querySelector("[data-hh-cart-subtotal]");
  var shipAmountEl = root.querySelector("[data-hh-cart-shipping]");
  var grandEl = root.querySelector("[data-hh-cart-grand]");
  var grandWasEl = root.querySelector("[data-hh-cart-was]");
  var saveBadgeEl = root.querySelector("[data-hh-cart-savebadge]");
  var shipMsgEl = root.querySelector("[data-hh-cart-shipmsg]");
  var shipFillEl = root.querySelector("[data-hh-cart-shipfill]");
  var shipMarks = Array.prototype.slice.call(
    root.querySelectorAll("[data-hh-cart-mark], [data-hh-cart-dot]"));

  var busy = false;
  var shipInit = false;          // eerste render van de verzendbalk zonder animatie
  var suppressIntercept = false; // onze eigen /cart/add niet dubbel afvangen
  var lastSignature = null;      // vingerafdruk van de laatst getekende cart

  /* ---------- schaduw op de footer zolang er inhoud boven de vouw zit ---------- */
  var scrollFadeQueued = false;
  function updateScrollFade() {
    if (!bodyEl) return;
    var moreBelow = bodyEl.scrollHeight - bodyEl.clientHeight - bodyEl.scrollTop > 4;
    // de oude witte vervaging is vervangen door een schaduw op de footer
    if (scrollFadeEl) scrollFadeEl.hidden = true;
    root.classList.toggle("is-scrolling", moreBelow);
  }
  // scroll en resize vuren vaak; koppel het werk aan één frame
  function queueScrollFade() {
    if (scrollFadeQueued) return;
    scrollFadeQueued = true;
    requestAnimationFrame(function () {
      scrollFadeQueued = false;
      updateScrollFade();
    });
  }
  if (bodyEl) bodyEl.addEventListener("scroll", queueScrollFade, { passive: true });
  window.addEventListener("resize", queueScrollFade);

  /* ---------- geld formatteren (NL) ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(".", ",");
    // duizendtallen
    var parts = v.split(",");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "\u20ac" + parts.join(",");
  }

  /* ---------- van-prijs per stuk bepalen ----------
     Chews: vaste €35,50 per pot. Andere producten: compare_at_price uit het
     product-endpoint (/products/{handle}.js), want /cart.js geeft die niet
     betrouwbaar terug. We cachen per handle zodat we niet dubbel ophalen. */
  /* ---------- eigen afbeelding per product ----------
     Sommige producten hebben als hoofdafbeelding een tekstbeeld, en dat is
     op 52 pixels onleesbaar. In het snippet staat per handle een vervanger;
     die lezen we hier één keer in. */
  var CART_IMAGES = (function () {
    var map = {};
    var ruw = root.getAttribute("data-cart-images") || "";
    ruw.split("||").forEach(function (paar) {
      var stuk = paar.split("|");
      var handle = (stuk[0] || "").trim();
      var bron = (stuk[1] || "").trim();
      if (handle && bron) map[handle] = bron;
    });
    return map;
  })();

  var compareCache = {}; // handle -> per-unit compare price (centen) of 0

  function compareUnitFor(item) {
    if (CHEWS_PRODUCT_IDS[String(item.product_id)]) {
      return CHEWS_COMPARE_PER_UNIT;
    }
    // uit cache (gevuld door prefetchCompare); anders wat cart geeft; anders 0
    if (item.handle && compareCache.hasOwnProperty(item.handle)) {
      return compareCache[item.handle];
    }
    return item.compare_at_price || 0;
  }

  // haalt voor alle niet-chews producten de compare_at op via het product-endpoint
  function prefetchCompare(cart) {
    var handles = {};
    cart.items.forEach(function (item) {
      if (CHEWS_PRODUCT_IDS[String(item.product_id)]) return; // chews: vaste prijs
      if (!item.handle) return;
      if (compareCache.hasOwnProperty(item.handle)) return;    // al gecached
      handles[item.handle] = item.variant_id;
    });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (handle) {
      return fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var wantVariant = handles[handle];
          var compare = 0;
          // zoek de juiste variant, val terug op de eerste met compare_at
          (p.variants || []).forEach(function (v) {
            if (String(v.id) === String(wantVariant) && v.compare_at_price) compare = v.compare_at_price;
          });
          if (!compare) {
            (p.variants || []).forEach(function (v) {
              if (!compare && v.compare_at_price) compare = v.compare_at_price;
            });
          }
          compareCache[handle] = compare || 0;
        })
        .catch(function () { compareCache[handle] = 0; });
    }));
  }

  /* ---------- thema-eigen drawer onderdrukken ---------- */
  function closeThemeDrawer() {
    // veelvoorkomende open-classes die thema's op <body>/<html> zetten
    var cls = ["side_Drawer_open", "yv_side_Drawer_open", "js-drawer-open", "drawer-open", "cart-open", "js-drawer-open-right"];
    cls.forEach(function (c) {
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    });
    // veelvoorkomende drawer-panelen sluiten via aria/class
    document.querySelectorAll("#mini__cart, .mini_cart, .yv_side_drawer_wrapper, .side-drawer, [data-side-drawer]").forEach(function (el) {
      el.classList.remove("is-open", "active", "open");
    });
  }

  /* ---------- open / dicht ----------
     open(true) = de aanroeper heeft de cart al opgehaald en getekend, dus
     niet nóg een keer ophalen. Dat scheelde de helft van alle verkeer. */
  function open(skipRefresh) {
    closeThemeDrawer();
    root.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("hh-cart-open");
    if (!skipRefresh) refresh();
    // nog een keer opruimen ná de thema-animatie, mocht 't thema 'm net erna openen
    setTimeout(closeThemeDrawer, 60);
    setTimeout(closeThemeDrawer, 250);
    setTimeout(updateScrollFade, 300);
  }
  function close() {
    root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("hh-cart-open");
  }
  function isOpen() {
    return root.getAttribute("aria-hidden") === "false";
  }
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-hh-cart-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) close();
  });

  /* ---------- Shopify cart API ----------
     Meerdere triggers kunnen vlak na elkaar de cart willen. Zolang er een
     aanvraag loopt geven we diezelfde promise terug, zodat er nooit twee
     identieke /cart.js-verzoeken naast elkaar staan. */
  var cartInFlight = null;
  function getCart() {
    if (cartInFlight) return cartInFlight;
    cartInFlight = fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartInFlight = null; return cart; })
      .catch(function (err) { cartInFlight = null; throw err; });
    return cartInFlight;
  }

  /* ---------- hoeveelheid wijzigen (gebundeld) ----------
     Het getal in beeld springt meteen mee; de daadwerkelijke aanvraag gaat
     pas 350 ms na de laatste klik weg. Vijf keer op + klikken kost dus één
     verzoek in plaats van vijf, en de wachttijd voor Pumper/BOGOS betaal
     je nog maar één keer per reeks. */
  var pendingQty = {};
  var flushTimer = null;

  function queueChange(key, qty) {
    pendingQty[key] = qty;
    root.classList.add("is-busy");
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flushChanges, 350);
  }

  function flushChanges() {
    var keys = Object.keys(pendingQty);
    var snapshot = pendingQty;
    pendingQty = {};
    if (!keys.length) { root.classList.remove("is-busy"); return; }

    var chain = Promise.resolve();
    keys.forEach(function (key) {
      chain = chain.then(function () {
        return fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: key, quantity: snapshot[key] })
        }).then(function (r) { return r.json(); });
      });
    });

    chain
      .then(function () {
        // Laat een eventuele kortings-app (bv. Pumper Bundles) de korting
        // opnieuw berekenen, en haal daarna een verse cart op zodat de
        // bijgewerkte prijzen kloppen (niet de tussenstand van change.js).
        if (typeof window.refreshCart === "function") { try { window.refreshCart(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        return new Promise(function (resolve) { setTimeout(resolve, 250); }).then(getCart);
      })
      .then(function (cart) { render(cart, true); syncThemeCount(cart); })
      .catch(function () {})
      .then(function () { root.classList.remove("is-busy"); });
  }

  /* ---------- upsells ----------
     Staan onderaan de scrollbare body, dus ze schuiven mee onder het
     ordertotaal-blok door. Een upsell verdwijnt zodra het product in de
     cart zit; is er niets meer te tonen, dan verdwijnt het hele blok. */
  function updateUpsells(cart) {
    if (!upsellsEl) return;
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[String(i.product_id)] = true; });

    var visible = 0;
    Array.prototype.forEach.call(upsellsEl.querySelectorAll("[data-upsell-product-id]"), function (el) {
      var hide = !!inCart[el.getAttribute("data-upsell-product-id")];
      el.hidden = hide;
      if (!hide) visible++;
    });
    upsellsEl.hidden = visible === 0 || (cart.item_count || 0) === 0;
  }

  function addToCart(variantId, btn) {
    if (busy) return;
    busy = true;
    suppressIntercept = true; // onze eigen add niet nog eens door de interceptor
    root.classList.add("is-busy");
    var label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Toevoegen\u2026"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (typeof window.refreshCart === "function") { try { window.refreshCart(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        return new Promise(function (resolve) { setTimeout(resolve, 250); }).then(getCart);
      })
      .then(function (cart) { render(cart, true); syncThemeCount(cart); })
      .catch(function () {})
      .then(function () {
        busy = false;
        suppressIntercept = false;
        root.classList.remove("is-busy");
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }

  if (upsellsEl) {
    upsellsEl.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-upsell-add]");
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest("[data-upsell-variant-id]");
      if (!card) return;
      addToCart(card.getAttribute("data-upsell-variant-id"), btn);
    });
  }

  /* ---------- render ---------- */
  function refresh() { getCart().then(function (c) { render(c); }); }

  /* Vingerafdruk van de cart. Is die gelijk aan de vorige, dan is er niets
     veranderd en hoeven we de regels niet opnieuw op te bouwen. */
  function signatureOf(cart) {
    var s = cart.item_count + "|" + cart.total_price;
    (cart.items || []).forEach(function (i) {
      s += "|" + i.key + ":" + i.quantity + ":" + i.final_line_price;
    });
    return s;
  }

  function render(cart, force) {
    if (!force && signatureOf(cart) === lastSignature) {
      // cart ongewijzigd: alleen de teller en de scrollschaduw bijwerken
      if (countEl) countEl.textContent = "(" + (cart.item_count || 0) + ")";
      updateScrollFade();
      return;
    }
    // eerst de van-prijzen ophalen (voor niet-chews), dan pas tekenen
    prefetchCompare(cart).then(function () { draw(cart); });
  }

  function draw(cart) {
    var count = cart.item_count || 0;
    if (countEl) countEl.textContent = "(" + count + ")";

    // leeg?
    var isEmpty = count === 0;
    emptyEl.hidden = !isEmpty;
    footEl.hidden = isEmpty;
    linesEl.hidden = isEmpty;

    // totaal aantal potten chews in de hele cart (voor de nudge)
    var chewsTotal = 0;
    cart.items.forEach(function (item) {
      if (CHEWS_PRODUCT_IDS[String(item.product_id)]) chewsTotal += item.quantity;
    });

    // regels — in één keer in de DOM hangen i.p.v. per stuk
    var frag = document.createDocumentFragment();
    var origSum = 0; // som van compare-at regelprijzen (van-prijzen), voor de totaalbadge
    var hasGift = false;
    cart.items.forEach(function (item) {
      // gratis cadeau telt niet mee in de totaalkorting
      if (item.final_line_price !== 0) {
        var compareUnit = compareUnitFor(item);
        var lineWas = compareUnit * item.quantity;
        origSum += (lineWas > item.final_line_price) ? lineWas : item.final_line_price;
      } else {
        hasGift = true;
      }
      frag.appendChild(buildLine(item, chewsTotal, cart.total_price));
    });
    linesEl.innerHTML = "";
    linesEl.appendChild(frag);

    // gratis-verzendingsbalk
    var subtotal = cart.total_price; // na line-kortingen, ex verzending
    updateShipBar(subtotal, hasGift);

    // totalen
    var shipping = subtotal >= FREE ? 0 : SHIP;
    subtotalEl.textContent = money(subtotal);

    if (shipping === 0) {
      shipAmountEl.innerHTML = '<span class="hh-cart__free">Gratis</span>';
    } else {
      shipAmountEl.textContent = money(shipping);
    }

    // ordertotaal: subtotaal + verzending. De van-prijs telt dezelfde
    // verzendkosten mee, zodat doorgestreepte en nieuwe prijs vergelijkbaar zijn.
    var grandNow = subtotal + shipping;
    var grandWas = origSum + shipping;
    grandEl.textContent = money(grandNow);

    var saving = origSum - subtotal;
    if (saving > 0 && origSum > 0) {
      grandWasEl.textContent = money(grandWas);
      grandWasEl.hidden = false;
      // percentage op de producten (dus zonder verzending), zodat het
      // overeenkomt met de badges op de productregels
      var pct = Math.floor((saving / origSum) * 100);
      saveBadgeEl.textContent = pct + "% korting";
      saveBadgeEl.hidden = false;
    } else {
      grandWasEl.hidden = true;
      saveBadgeEl.hidden = true;
    }

    // upsells bijwerken (verbergen wat al in de cart zit)
    updateUpsells(cart);

    // onthouden wat we net getekend hebben
    lastSignature = signatureOf(cart);

    // scroll-fade bijwerken nadat de regels getekend zijn
    updateScrollFade();
  }

  function buildLine(item, chewsTotal, subtotal) {
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute("data-line-key", item.key);

    var img = node.querySelector("[data-line-image]");
    // Eigen afbeelding gaat voor de hoofdafbeelding van het product.
    var eigen = item.handle && CART_IMAGES[item.handle];
    if (eigen) {
      img.src = eigen;
      img.alt = item.product_title || "";
    } else if (item.image) {
      img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2");
      img.alt = item.product_title || "";
    } else {
      img.remove();
    }
    Array.prototype.forEach.call(node.querySelectorAll("[data-line-url]"), function (a) { a.href = item.url; });
    node.querySelector("[data-line-title]").textContent = item.product_title;

    // prijzen — REGELPRIJS (quantity × prijs), van-prijs uit compare_at_price
    var nowEl = node.querySelector("[data-line-now]");
    var wasEl = node.querySelector("[data-line-was]");
    var lineNow = item.final_line_price;              // wat de klant betaalt voor deze regel
    // van-prijs: chews vast €35,50/pot, anders compare_at_price; × aantal
    var compareUnit = compareUnitFor(item);
    var lineWas = compareUnit * item.quantity;
    nowEl.textContent = money(lineNow);

    var badge = node.querySelector("[data-line-badge]");
    if (lineNow === 0) {
      // gratis cadeau van BOGOS: geen kortingspercentage maar een cadeau-label
      badge.textContent = "\ud83c\udf81 Jouw gratis product";
      badge.classList.add("is-gift");
      badge.hidden = false;
      if (lineWas > 0) {
        wasEl.textContent = money(lineWas);
        wasEl.hidden = false;
      }
    } else if (lineWas > lineNow) {
      wasEl.textContent = money(lineWas);
      wasEl.hidden = false;
      var pct = Math.floor(((lineWas - lineNow) / lineWas) * 100);
      if (pct > 0) {
        badge.textContent = pct + "% korting";
        badge.hidden = false;
      }
    }

    var qtyEl = node.querySelector("[data-line-qty]");
    qtyEl.textContent = item.quantity;

    // nudge: alleen bij precies één pot chews én zolang de gratis-verzendingsdrempel
    // nog niet is gehaald — daarboven voegt de boodschap niets meer toe
    var nudge = node.querySelector("[data-line-nudge]");
    if (nudge && CHEWS_PRODUCT_IDS[String(item.product_id)] && chewsTotal === 1 && subtotal < FREE) {
      var twoWas = CHEWS_COMPARE_PER_UNIT * 2;
      var twoNow = CHEWS_BUNDLE_PRICES[2];
      var bundlePct = Math.floor(((twoWas - twoNow) / twoWas) * 100);
      var thenFree = (subtotal - item.final_line_price + twoNow) >= FREE;

      var benefit = thenFree
        ? "gratis verzending en " + bundlePct + "% korting"
        : bundlePct + "% korting";

      node.querySelector("[data-line-nudge-text]").innerHTML =
        "Maak er 2 van voor <strong>" + benefit + "</strong>";
      nudge.hidden = false;
    }

    // events — het getal reageert direct, de aanvraag volgt gebundeld
    var qty = item.quantity;
    node.querySelector("[data-line-inc]").addEventListener("click", function () {
      qty += 1;
      qtyEl.textContent = qty;
      queueChange(item.key, qty);
    });
    node.querySelector("[data-line-dec]").addEventListener("click", function () {
      if (qty <= 0) return;
      qty -= 1;
      if (qty === 0) node.hidden = true;
      else qtyEl.textContent = qty;
      queueChange(item.key, qty);
    });
    node.querySelector("[data-line-remove]").addEventListener("click", function () {
      qty = 0;
      node.hidden = true;
      queueChange(item.key, 0);
    });

    return node;
  }

  function updateShipBar(subtotal, hasGift) {
    var reached = subtotal >= FREE;
    var giftReached = GIFT > 0 && subtotal >= GIFT;
    root.classList.toggle("is-free", reached);
    root.classList.toggle("is-gift", giftReached);

    // Elke mijlpaal licht op zodra je er voorbij bent.
    shipMarks.forEach(function (mk) {
      var at = parseInt(mk.getAttribute("data-at"), 10) || 0;
      mk.classList.toggle("is-reached", subtotal >= at);
    });

    // De mijlpalen staan op de helft en aan het eind van de balk, niet op
    // hun bedrag. De vulling volgt dat: de eerste helft telt af naar de
    // gratis verzending, de tweede helft naar het cadeau.
    var pct;
    if (GIFT > 0) {
      if (subtotal >= GIFT) {
        pct = 1;
      } else if (subtotal >= FREE) {
        pct = 0.5 + 0.5 * ((subtotal - FREE) / (GIFT - FREE));
      } else {
        pct = 0.5 * (subtotal / FREE);
      }
    } else {
      pct = Math.max(0, Math.min(1, subtotal / BAR_MAX));
    }
    pct = Math.max(0, Math.min(1, pct));
    // ondergrens: truck zit aan het eind van de vulling, dus houd 'm net op de balk
    // (anders valt 'ie bij een lege cart half buiten de linkerrand)
    var MIN_PCT = 0.05;
    if (pct < MIN_PCT) pct = MIN_PCT;
    // eerste keer: zonder animatie meteen op de juiste breedte (geen 'sprong')
    if (!shipInit) {
      shipFillEl.style.transition = "none";
      shipFillEl.style.width = (pct * 100) + "%";
      // forceer reflow, zet transitie daarna terug voor volgende updates
      void shipFillEl.offsetWidth;
      shipFillEl.style.transition = "";
      shipInit = true;
    } else {
      shipFillEl.style.width = (pct * 100) + "%";
    }
    // Drie standen: nog niet bij de verzending, ertussenin, of allebei gehaald.
    if (GIFT > 0) {
      if (giftReached) {
        shipMsgEl.innerHTML = "\ud83c\udf89 Je hebt <strong>gratis verzending en een gratis cadeau</strong>!";
      } else if (reached) {
        shipMsgEl.innerHTML = "Nog <strong>" + money(GIFT - subtotal) +
          "</strong> voor een gratis cadeau!";
      } else {
        shipMsgEl.innerHTML = "Nog <strong>" + money(FREE - subtotal) +
          "</strong> voor gratis verzending!";
      }
    } else if (reached) {
      shipMsgEl.innerHTML = hasGift
        ? "\ud83c\udf89 Je hebt <strong>gratis verzending en een gratis product</strong>!"
        : "\ud83c\udf89 Je hebt <strong>gratis verzending</strong>!";
    } else {
      shipMsgEl.innerHTML = "Nog <strong>" + money(FREE - subtotal) +
        "</strong> voor gratis verzending!";
    }
  }

  /* ---------- header-badge van het thema meenemen ---------- */
  function syncThemeCount(cart) {
    var n = cart.item_count;
    document.querySelectorAll(
      ".cartCount, .cart-count-bubble, [data-cart-count], .cart-count, .header__cart-count, .site-header__cart-count"
    ).forEach(function (el) {
      var digits = el.querySelector("span") || el;
      digits.textContent = n;
    });
  }

  /* ---------- triggers: open onze drawer i.p.v. thema-cart ---------- */
  function isCartTrigger(el) {
    if (!el) return false;
    if (el.closest("[data-hh-cart-open]")) return true;
    var a = el.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (a && !a.hasAttribute("data-no-hh-cart")) return true;
    // theme-specifieke cart-triggers (o.a. dit thema: .openCartDrawer)
    if (el.closest(".openCartDrawer, .cart-icon, .header__icon--cart, [data-cart-toggle], #cart-icon-bubble")) return true;
    return false;
  }
  document.addEventListener("click", function (e) {
    if (isCartTrigger(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
    }
  }, true);

  /* ---------- na 'toevoegen aan winkelwagen' automatisch openen ----------
     Drie triggers kunnen vlak na elkaar afgaan (fetch, XHR, klik-vangnet).
     Deze functie zorgt dat er per handeling maar één keer werk gebeurt. */
  var lastAutoRefresh = 0;
  function autoRefreshOpen() {
    var now = Date.now();
    if (now - lastAutoRefresh < 1200) return; // net al gedaan
    lastAutoRefresh = now;
    getCart().then(function (c) {
      render(c, true);
      syncThemeCount(c);
      open(true); // niet nóg een keer ophalen
    });
  }

  // onderschep fetch naar /cart/add
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var p = _fetch.apply(this, arguments);
    try {
      var u = typeof url === "string" ? url : (url && url.url);
      if (u && /\/cart\/add(\.js)?/.test(u) && !suppressIntercept) {
        p.then(function (res) {
          if (res && res.ok) autoRefreshOpen();
        }).catch(function () {});
      }
    } catch (err) {}
    return p;
  };
  // onderschep klassieke XHR add-to-cart
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener("load", function () {
      if (typeof url === "string" && /\/cart\/add(\.js)?/.test(url) && this.status >= 200 && this.status < 300) {
        autoRefreshOpen();
      }
    });
    return _open.apply(this, arguments);
  };

  /* ---------- vangnet: directe klik op 'toevoegen'-knop van dit thema ----------
     Sommige thema's voegen toe zonder dat fetch/XHR duidelijk /cart/add raakt,
     of openen daarna hun eigen drawer. We luisteren daarom óók direct op de
     toevoegen-knop. Dankzij autoRefreshOpen levert dat geen dubbel werk op
     als de fetch-interceptor al is afgegaan, dus één timer volstaat.
     De upsell-knop in de drawer zelf slaan we over: die regelt z'n eigen refresh. */
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-upsell-add]")) return;
    var btn = e.target.closest(".Sd_addProduct, .add_to_cart, [name='add'], button[type='submit'].add_to_cart");
    if (!btn) return;
    // even wachten tot het thema z'n add-request heeft afgerond, dan onze drawer tonen
    setTimeout(autoRefreshOpen, 400);
  }, true);

  /* ---------- USP-carrousel (alle schermformaten) ----------
     Toont één USP tegelijk en wisselt elke 3s met een swipe.
     Staat stil zolang de drawer dicht is — die deed anders de hele
     sessie door werk dat niemand ziet. */
  (function initUspCarousel() {
    var uspList = root.querySelector("[data-hh-cart-usps]");
    if (!uspList) return;
    var items = Array.prototype.slice.call(uspList.querySelectorAll("li"));
    if (items.length < 2) { if (items[0]) items[0].classList.add("is-active"); return; }

    var idx = 0;
    function show(i) {
      items.forEach(function (li, n) {
        li.classList.remove("is-active", "is-leaving");
        if (n === i) li.classList.add("is-active");
        else if (n === ((i - 1 + items.length) % items.length)) li.classList.add("is-leaving");
      });
    }
    show(0);
    setInterval(function () {
      if (!isOpen()) return; // drawer dicht: niets te zien, dus niets te doen
      idx = (idx + 1) % items.length;
      show(idx);
    }, 3000);
  })();

  // expose
  window.hhOpenCart = open;
  window.hhCloseCart = close;
  window.hhRefreshCart = refresh;

  // eerste vulling (badge klopt bij laden)
  getCart().then(function (c) { if (countEl) countEl.textContent = "(" + c.item_count + ")"; syncThemeCount(c); });
})();